module.exports = __webpack_public_path__ + "img/top-10-map.a50b0c41.jpg";